import { purify } from "../../../../_src/components/purify";

export function getResults(url, resultId, filterId, loaderId) {
  function search() {
    var form = document.querySelector(`${filterId}`);
    var data = new FormData(form);

    document.querySelectorAll(`${filterId} fieldset`).forEach(function (el) {
      el.classList.add("disabled")
    })

    if (loaderId) {
      document.querySelector(`.loader-${loaderId}`).classList.remove("hidden")
      document.querySelector(`${resultId}`).innerHTML = '';
    }

    fetch(`${url}`, {
      method: "POST",
      body: data
    }).then((response) => {
      return response.text();
    }).then((response) => {
      document.querySelector(`${resultId}`).innerHTML = purify(response);
    })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        if (loaderId) {
          document.querySelector(`.loader-${loaderId}`).classList.add("hidden")
        }

        document.querySelectorAll(`${filterId} fieldset`).forEach(function (el) {
          el.classList.remove("disabled")
        })
      });
  }

  document.querySelector(`${filterId}`).addEventListener("change", function () { setTimeout(() => { search() }, 100) })
  return search();
}

if (document.querySelector("#filter-transfers")) {
  getResults("/senar/transparencia-e-prestacao-de-contas/licitacoes-e-contratos/ajax/transfers.html", "#result-transfers", "#filter-transfers", "transfers");
}

